//const baseUrl = process.env.REACT_APP_API_URL_TEST; //test
const baseUrl = process.env.REACT_APP_API_URL;
const imageBaseUrl = process.env.REACT_APP_API_URL;
console.log("apiUrl", baseUrl,'imageBaseUrl',imageBaseUrl);

const UrlConstant = {
  thumbImageURL: imageBaseUrl + "images",
  MatchList: baseUrl + "api/Matches/embed/",
  refereeStream: baseUrl + "api/Match/GetStreams/",
};

export default UrlConstant;
